import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  body: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 32,
    margin: '-24px -40px -32px 0',
    [breakpointsFunc.breakpoints.down('lg')]: {
      margin: '-24px -24px -40px 0'
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 24,
      margin: '0 -24px -24px 0'
    }
  },
  formColumn: {
    flex: 3,
    minWidth: 0,
    padding: '24px 0 32px 0'
  },
  railColumn: {
    flex: 2,
    minWidth: 0,
    padding: '24px 40px 24px 28px',
    borderLeft: "1px solid ".concat(palette.shades[300]),
    backgroundColor: palette.shades[200],
    [breakpointsFunc.breakpoints.down('lg')]: {
      padding: '24px 24px 24px 24px'
    }
  },
  field: {
    width: '100%',
    marginBottom: 8
  },
  datePickerGate: {
    minWidth: 0,
    margin: 0,
    padding: 0,
    border: 0
  },
  helper: {
    display: 'block',
    color: palette.shades[600],
    marginBottom: 20
  },
  amountAdornment: {
    color: palette.shades[600],
    marginRight: 4
  },
  amountError: {
    display: 'block',
    color: palette.error.dark,
    marginBottom: 20
  },
  reasonCounter: {
    display: 'block',
    textAlign: 'right',
    color: palette.shades[600],
    marginTop: 4
  },
  callout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    marginTop: 20,
    padding: '16px 18px',
    borderRadius: 4,
    '& .MuiSvgIcon-root': {
      width: 20,
      height: 20,
      flexShrink: 0,
      marginTop: 2
    },
    '& .MuiTypography-root': {
      color: 'inherit'
    }
  },
  calloutCharge: {
    backgroundColor: palette.warning.light,
    color: palette.warning.dark,
    '& .MuiSvgIcon-root path': {
      fill: palette.warning.main
    }
  },
  calloutImpact: {
    backgroundColor: palette.info.light,
    color: palette.info.dark,
    '& .MuiSvgIcon-root path': {
      fill: palette.info.main
    }
  },
  calloutError: {
    backgroundColor: palette.error.light,
    color: palette.error.dark,
    '& .MuiSvgIcon-root path': {
      fill: palette.error.main
    }
  },
  calloutTitle: {
    '&&': {
      fontFamily: palette.fontFamilies.poppins,
      fontWeight: 600,
      fontSize: 15,
      lineHeight: 1.4
    }
  },
  calloutLine: {
    '&&': {
      display: 'block',
      marginTop: 6,
      fontFamily: palette.fontFamilies.source,
      fontWeight: 400,
      fontSize: 15,
      lineHeight: 1.55,
      textAlign: 'left',
      textWrap: 'pretty'
    }
  },
  confirmDanger: {
    '& .MuiButton-root': {
      backgroundColor: palette.error.main,
      color: palette.common.white,
      '&:hover': {
        backgroundColor: palette.error.dark
      },
      '&.Mui-disabled': {
        backgroundColor: palette.shades[400],
        color: palette.shades[100]
      }
    }
  }
});
export default useStyles;